import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import Login from "../Pages/Authentication/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Products from "../Pages/DataSet/Index";
import NotFound from "../Pages/Error/Error404";
import UserManagement from "../Pages/UserManagement/Index";
import CartDetails from "../Pages/UserManagement/Cart";
 import DataSet from "../Pages/DataSet/Index";
import ChatLogs from "../Pages/ChatLogs";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicRoutes />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Private Routes */}
      <Route element={<PrivateRoutes />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dataset" element={<DataSet/>} />
        <Route path="/chatlogs" element={<ChatLogs/>} />
        <Route path="/users" element={<UserManagement/>} />
        <Route path="/users/cart/:id" element={<CartDetails />} />
      </Route>
      {/* Fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
